// extracted by mini-css-extract-plugin
export var carrierNotice = "_lh-5";
export var carrierNoticePlaceholder = "_lh-6";
export var deliveryRow = "_lh-c";
export var fixedHeight = "_lh-4";
export var freightLogo = "_lh-b";
export var fullWidth = "_lh-3";
export var priceColumn = "_lh-7";
export var radioSelected = "_lh-9";
export var radioUnselected = "_lh-8";
export var selectedOption = "_lh-2";
export var selectedOptionContainer = "_lh-1";
export var selection = "_lh-0";
export var tallSkeletonText = "_lh-a";